import * as React from 'react';
import Marker from './Marker';
import { IMapClusters, MapClustersTypes } from 'src/share/components/Maps/MapClusters/MapClusters';
import { getZoom } from 'src/share/utils/utils';

export interface IClusterMarkerProps {
  centerBoundsPoints: () => void;
  history: any;
  lat: number;
  lng: number;
  mapType: MapClustersTypes;
  points: IMapClusters[];
  radius: number;
  zoom: number;
}
export interface IClusterMarkerState {
  clusterFaceMarkers: IMapClusters[];
}

class ClusterMarker extends React.PureComponent<IClusterMarkerProps, IClusterMarkerState> {
  constructor(props: IClusterMarkerProps) {
    super(props);
    this.state = {
      clusterFaceMarkers: this.props.points.slice(0, 2)
    };
  }
  public render() {
    const { centerBoundsPoints, radius, history, points, lat, lng, zoom, mapType } = this.props;
    const isAlertClusterMap = mapType === MapClustersTypes.ALERTS;
    const mapIsClose = zoom < (isAlertClusterMap ? (getZoom(radius) + 2 ): 12);
    return (
      <div className={mapIsClose ? 'MarkerGroup' : ''} style={{ width: points.length === 2 ? '55px' : '80px' }}>
        {
          this.state.clusterFaceMarkers.map(marker =>
            <Marker
              points={[marker]}
              key={marker.id}
              id={marker.id}
              lat={lat}
              lng={lng}
              radius={marker.radius}
              mapType={this.props.mapType}
              zoom={zoom}
              inGroup={points.length > 1}
              centerBoundsPoints={centerBoundsPoints}
              history={history}
            />)
        }
        {
          points.length > 2 && mapIsClose &&
          <div className="MarkerCounter">
            +{points.length - 2}
          </div>
        }
      </div >
    );
  }
}

export default ClusterMarker;



// WEBPACK FOOTER //
// ./src/share/components/Maps/MapClusters/components/ClusterMarker.tsx